import { useCallback, useState } from 'react';

export const useControlledState = <T>(
  controlledValue: T | undefined,
  defaultValue: T
): [T, (value: T) => void, boolean] => {
  const [internalValue, setInternalValue] = useState<T>(defaultValue);
  const isControlled = controlledValue !== undefined;
  const value = isControlled ? controlledValue : internalValue;

  const setValue = useCallback(
    (value: T) => {
      if (!isControlled) {
        setInternalValue(value);
      }
    },
    [isControlled]
  );

  return [value, setValue, isControlled];
};
